import { ArrowForward, FileDownloadOutlined } from "@mui/icons-material";
import { Box, BoxProps, Typography } from "@mui/material";
import { grey, indigo } from "../../../colors";

type SideMenuItemProps = {
  icon: React.ReactNode;
  rightIcon?: React.ReactNode;
} & BoxProps;

export default function SideMenuItem({ icon, rightIcon = <ArrowForward />, children, ...props }: SideMenuItemProps) {
  return (
    <Box
      {...props}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1,
        borderRadius: "12px",
        transition: "background-color 0.15s ease",
        "&:hover": { backgroundColor: grey[100] },
        "& > .MuiBox-root": { alignContent: "center" },
      }}
    >
      <Box
        sx={{
          backgroundColor: indigo[100],
          borderRadius: "12px",
          color: indigo[900],
          aspectRatio: "1/1",
          width: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          padding: "10px",
        }}
      >
        {icon}
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: indigo[900] }}>{children}</Typography>
      </Box>

      <Box sx={{ color: grey[500], display: "flex" }}>{rightIcon}</Box>
    </Box>
  );
}
